// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SFm23cU49qI185RKD9h5{padding:0 24px 24px}.VfvqyR5wBrQbgned0Xn3{padding-top:4px;padding-bottom:4px}.DDxZHD1VDv0yByq8AOhz{color:var(--red-60);align-items:center;gap:4px;font-size:11px;font-weight:400;display:flex}.e3cYZuDYMUcT37RYSr0C{justify-content:flex-end;gap:8px;margin-top:32px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `SFm23cU49qI185RKD9h5`,
	"wrapInput": `VfvqyR5wBrQbgned0Xn3`,
	"errorContainer": `DDxZHD1VDv0yByq8AOhz`,
	"actions": `e3cYZuDYMUcT37RYSr0C`
};
export default ___CSS_LOADER_EXPORT___;
